import React, { useEffect, useState } from 'react';
import { Spin, Modal, Tooltip } from 'antd';
import { LoadingOutlined, PrinterOutlined } from '@ant-design/icons';
import './printSlide.css';
import '../modalStyles.css';
import { useReactToPrint } from 'react-to-print';
import PrintContainer from './printContainer';

const PrintSlide = () => {
    const [isPrinting, setIsPrinting] = useState(false);
    const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

    const handlePrint = () => {
        setIsPrinting(true);
        setIsGeneratingPreview(true);
        setTimeout(() => {
            setIsGeneratingPreview(false);
        }, 800);
    };

    const printSlides = useReactToPrint({
        content: () => document.getElementById("print-slide-container"),
        onAfterPrint: () => {
            setIsGeneratingPreview(false);
            setIsPrinting(false);
        }
    });

    useEffect(() => {
        if (isPrinting && !isGeneratingPreview) {
            printSlides();
        }

    }, [isPrinting, isGeneratingPreview]);

    return (
        <div>
            <Tooltip title="Print" placement="bottom">
                <button className="header-icon-btn" onClick={handlePrint} aria-label="Print">
                    <PrinterOutlined style={{ fontSize: '16px' }} />
                </button>
            </Tooltip>
            <Modal
                title="Generating preview"
                visible={isGeneratingPreview}
                closable={false}
                footer={null}
                width={280}
                centered
                maskClosable={false}
                className="export-document-modal slide-preview-modal"
            >
                <div className="slide-preview-modal__body">
                    <p className="slide-preview-modal__subtitle">This may take a few moments</p>
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 28,
                                    fontWeight: 'bold',
                                    color: 'black'
                                }}
                                spin
                            />
                        }
                    />
                    <p className="slide-preview-modal__hint">Preparing printable layout...</p>
                </div>
            </Modal>
            {isPrinting &&
            <div id="print-slide-container" style={{ display: 'none' }}>
                <PrintContainer />
            </div>
            }
        </div>
    );
};

export default PrintSlide;